/* eslint-disable default-param-last */
import {
  TAB_STATUS_ALL,
  TAB_STATUS_CONS,
  TAB_STATUS_DONE,
  TAB_STATUS_TODO,
} from '../../../components/ViewControls';
import {
  SET_CERT_TABS,
  SET_TAB_COUNTS_DISABLED,
  SET_TAB_COUNTS_ERROR,
  SET_TAB_COUNTS_LOADING,
  SET_TAB_COUNTS_SUCCESS,
  SET_TABHIGHLIGHT_NAME,
} from '../types';

const INITIAL_STATE = {
  tabData: [
    {
      key: TAB_STATUS_TODO,
      count: 0,
      label: 'To Do',
      isActive: true,
      isHighlighted: false,
    },
    {
      key: TAB_STATUS_DONE,
      count: 0,
      label: 'Done',
      isActive: false,
      isHighlighted: false,
    },
    {
      key: TAB_STATUS_CONS,
      count: 0,
      label: 'Consulted',
      isActive: false,
      isHighlighted: false,
    },
    {
      key: TAB_STATUS_ALL,
      count: 0,
      label: 'All',
      isActive: false,
      isHighlighted: false,
    },
  ],
  isDisabled: false,
  isLoading: false,
  isError: false,
  errorMessage: false,
  highlightTabName: null,
};

const tabsReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_CERT_TABS:
      return {
        ...state,
        tabData: action?.payload?.results,
      };

    case SET_TABHIGHLIGHT_NAME:
      return {
        ...state,
        highlightTabName: action?.payload,
      };

    case SET_TAB_COUNTS_DISABLED:
      return {
        ...state,
        isDisabled: action?.payload,
      };

    case SET_TAB_COUNTS_LOADING:
      return {
        ...state,
        isLoading: true,
        isError: false,
        errorMessage: null,
      };

    case SET_TAB_COUNTS_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
        errorMessage: action.payload.error,
      };

    case SET_TAB_COUNTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errorMessage: null,
        tabData: state?.tabData?.map((tab) =>
          tab.key === action.payload.tab
            ? { ...tab, count: action.payload.count }
            : tab
        ),
      };

    default:
      return state;
  }
};

export default tabsReducer;
